<template>
    <modal
        :name="'editarDescuento-' + localDescuento.id"
        transition="pop-out"
        :width="800"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Editar precio - {{ localDescuento.descripcion }}</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close(false)">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <FormDescuento :descuento="localDescuento" v-on:terminado=" (descuento) => editarDescuento(descuento)"/>
            </div>
            <div class="card-footer text-right">
                <Button type="button" name="button" @click.prevent="close(false)">CERRAR</Button>
            </div>
        </div>
    </modal>
</template>

<script>

    import FormDescuento from './FormDescuento';

    export default {
        props: ['lista_id', 'precio_id', 'descuento'],
        data() {
            return {
                loading: false,
                localDescuento: { ...this.descuento }
            }
        },
        methods: {
            close(creado) {
                this.$emit('close', 'editarDescuento-' + this.localDescuento.id, creado);
            },
            editarDescuento(descuento) {
                this.loading = true;

                descuento.filters = {};
                descuento.lista_id = this.lista_id;
                descuento.precio_id = this.precio_id;
                descuento.descuento_id = descuento.id;

                this.$store.dispatch(this.config.getVuexAlias('back.precios.descuentos.editar'), descuento).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            FormDescuento
        }
    }
</script>